export default {
  'a_homeClickStartStationItem': {
    topicDesc: '系统首页-启动台',
    typeStatus:{},
    typeValue: {
      'add-employee':'添加员工',
      'report-employee':'导入员工',
      'report-employee-info':'导入员工信息',
      'monthly-personnel-report':'人事月报',
      'attendance-setting':'考勤设置',
      'attendance-report':'考勤报表',
      'employee-tool':'员工成本计算',
      'payroll-tool':'税前工资反推',
      'insurance-tool':'社保公积金测算',
      'option-tool':'期权授予计算'
    }
  },
  'a_homeClickUserMessage': {
    topicDesc: '系统首页-个人信息查看',
    typeStatus:{},
    typeValue: {
      'portrait':'头像-个人档案',
      'personalInfo':'员工信息',
      'jobInfo':'岗位信息',
      'rewardInfo':'奖惩信息',
      'stockInfo':'期权信息',
    }
  },
  'a_homeClickCalendarSchedule': {
    topicDesc: '系统首页-考勤&日程查看',
    typeStatus:{},
    typeValue: {
      'pre':'日历-向前切换',
      'next':'日历-向后切换',
      'today':'日历-今天',
      'date':'日历-点击日期切换',
      'reminder-add':'备忘-新增',
      'reminder-edit':'备忘-编辑',
      'reminder-delete':'备忘-删除',
      'entry':'统计数据-待入职',
      'dismiss':'统计数据-待离职',
      'sign':'统计数据-待续签',
      'probation':'统计数据-试用期到期',
      'approve-bk':'考勤-补卡',
      'approve-detail':'考勤-查看审批',
      'interview-resume':'日程-查看简历',
    }
  },
  'a_homeClickQuickEntrance': {
    topicDesc: '系统首页-快捷入口点击',
    typeStatus:{},
    typeValue: {
      'apply':'申请',
      'leave':'请假',
      'goOut':'外出',
      'workOvertime':'加班',
      'approveList':'我的审批',
      'recruitment':'我的招聘',
      'okr':'我的OKR',
      'kpi':'我的绩效',
      'contract':'电子合同',
      'payroll':'我的工资条',
      'attendanceConfirm':'考勤确认',
      'bonusPackage':'我的奖金包',
      'projectManage':'项目管理',
      'train':'我的培训',
    }
  },

  'a_homeClickPageTop': {
    topicDesc: '系统首页-返回顶部',
    typeStatus:{},
    typeValue: {}
  },


  'a_employeeWorkbenchSet': {
    topicDesc: "系统首页-工作台设置",
    typeStatus: {},
    typeValue: {
      '0':'取消置顶',
      '1':'置顶卡片'
    }
  },
  'a_employeeWorkbenchOverview': {
    topicDesc: "系统首页-概况点击",
    typeStatus: {
      'home':'分公司首页',
      'employee':'员工工作台'
    },
    typeValue: {
      '100': '概况-员工总数',
      '101': '概况-编制',
      '0': '概况-正式',
      '10': '概况-实习',
      '15': '概况-兼职',
      '14': '概况-外包',
      '13': '概况-返聘',
      '11': '概况-劳务',
      '12': '概况-顾问',
    }
  },
  'a_homeClickCardLabelFilter': {
    topicDesc: '系统首页-标签筛选',
    typeStatus:{
      'home':'首页'
    },
    typeValue: {
      '-1':'取消筛选',
      'myTodo':'我的待办',
      'entry':'入职',
      'regular':'转正',
      'transfer':'调动',
      'dismiss':'离职',
      'statistic':'数据看板',
      'okr':'OKR',
      'noInformation':'信息待完善',
      'care':'员工关怀', 
      'contract':'合同',
      'account':'账号', 
      'organization':'组织管理',
    }
  },
  'a_employeeWorkbenchTodayEntry': {
    topicDesc: "系统首页-今日入职点击",
    typeStatus: {
      'home':'分公司首页',
      'employee':'员工工作台'
    },
    typeValue: {
      '1': '待入职总数',
      '2': '待入职头像',
      '3': '已入职总数',
      '4': '已入职头像',
      '5': '30天待入职',
      '6': '30天待入职头像',
    }
  },
  'a_employeeWorkbenchTodayDismiss': {
    topicDesc: "系统首页-今日离职点击",
    typeStatus: {
      'home':'分公司首页',
      'employee':'员工工作台'
    },
    typeValue: {
      '1': '待离职总数',
      '2': '待离职头像',
      '3': '已离职总数',
      '4': '已离职头像',
      '5': '30天待离职',
      '6': '30天待离职头像',
    }
  },
  'a_employeeWorkbenchFutureRegular': {
    topicDesc: "系统首页-30天待转正点击",
    typeStatus: {
      'home':'分公司首页',
      'employee':'员工工作台'
    },
    typeValue: {
      '1': '待转正总数',
      '2': '待转正-未发起',
      '3': '待转正-流程中',
      '4': '待转正-待生效',
      '5': '待转正-即将超期'
    }
  },
  'a_employeeWorkbenchFutureSign': {
    topicDesc: "系统首页-45天内待续签点击",
    typeStatus: {
      'home':'分公司首页',
      'employee':'员工工作台'
    },
    typeValue: {
      '1': '待续签-未发起',
      '2': '待续签-流程中',
      '3': '待续签-即将超期'
    }
  },
  'a_employeeWorkbenchOverdue': {
    topicDesc: "系统首页-已超期点击",
    typeStatus: {
      'home':'分公司首页',
      'employee':'员工工作台'
    },
    typeValue: {
      'detail':'已超期-员工详情',
      'entry': '已超期-入职',
      'regular': '已超期-转正',
      'dismission': '已超期-离职',
      'transferJob':'已超期-调动',
      'renewContract':'已超期-合同续签'
    }
  },
  'a_employeeWorkbenchProgramMissing': {
    topicDesc: "系统首页-方案缺失点击",
    typeStatus: {
      'home':'分公司首页',
      'employee':'员工工作台'
    },
    typeValue: {
      'noEntryPlan': '入职方案缺失',
      'noProbationPeriodPlan': '试用期方案缺失',
      'noDisMissionHandover': '离职交接方案缺失'
    }
  },
  'a_workbenchRemind': {
    topicDesc: "系统首页-提醒点击",
    typeStatus: {
      'home':'分公司首页',
      'employee':'员工工作台'
    },
    typeValue: {
      'infoSubmit': '提交入职登记表',
      'noTutor': '无试用期导师',
      'noTask': '无试用期任务',
      'handoverFinish':'离职交接已完成',
      'elecSign':'电子合同已签署',
      'birthday':'即将过生日',
      'anniversary':'即将周年',
      'earliestRetireHalfYear': '最早半年内可弹性退休',
      'earliestRetireNextMonth': '最早下个月可弹性退休',
      'earliestRetireCurrentMonth': '最早本月可弹性退休',
      'approvedRetireHalfYear': '半年内到达核准退休月份',
      'approvedRetireNextMonth': '下个月到达核准退休月份',
      'approvedRetireCurrentMonth': '本月到达核准退休月份'
    }
  },
  'a_workbenchWarning': {
    topicDesc: "系统首页-预警点击",
    typeStatus: {
      'home':'分公司首页',
      'employee':'员工工作台'
    },
    typeValue: {
      'subordinateOver': '下属超15人',
      'departmentHeadcountOver': '部门超编',
      'dismissRate': '离职率过高',
      'probationDismissRate':'试用期离职率过高'
    }
  },
  'a_homeClickLatestNews': {
    topicDesc: '系统首页-用户中心',
    typeStatus:{},
    typeValue: {
      'video':'直播OR场景案例',
      'notice':'上线公告',
      'more':'更多',
      'allUpdateLog':'全部升级日志'
    }
  },
  'a_homeClickadvertisement': {
    topicDesc: '系统首页-运营位',
    typeStatus:{},
    typeValue: {
      1:'查看详情',
      2:'关闭'
    }
  },
  'a_homeClickImportantMatter': {
    topicDesc: '系统首页-重要事项',
    typeStatus:{},
    typeValue: {
      1:'公告待确认',
      2:'工资条待确认',
      3:'考勤待确认'
    }
  },
  'a_homeClickMyApproval': {
    topicDesc: '系统首页-我的审批',
    typeStatus:{},
    typeValue: {
      'detail':'进入审批详情',
      'transmit':'转发',
      'approve':'通过',
      'reject':'驳回',
      'urge':'催办',
      'cancel':'撤销',
      'more':'更多'
    }
  },
  'a_homeClickMyAppraisal': {
    topicDesc: '系统首页-我的绩效',
    typeStatus:{},
    typeValue: {
      'detail':'进入绩效详情',
      'more':'更多'
    }
  },
  'a_homeClickAssessmentResume': {
    topicDesc: '系统首页-待评估简历',
    typeStatus:{},
    typeValue: {
      'detail':'进入简历详情',
      'more':'更多'
    }
  },
  'a_homeClickNoticeList': {
    topicDesc: '系统首页-公告',
    typeStatus:{},
    typeValue: {
      'detail':'进入公告详情',
      'more':'更多'
    }
  },
  'a_appraisalClickMyOkr': {
    topicDesc: '系统首页-我的OKR',
    typeStatus:{
      '1': '管理端'
    },
    typeValue: {
      '1': '查看目标详情',
      '2': '查看他人目标',
      '3': '更新目标进度',
      '4': '添加对齐',
      '5': '导出目标数据'
    }
  },
  'a_homeClickMyOkr': {
    topicDesc: '系统首页-我的OKR',
    typeStatus:{},
    typeValue: {
      '1': '点击OKR目标',
      '2': '点击员工头像',
      '3': '点击更多员工数字',
      '4': '更新进度',
      '5': '添加对齐'
    }
  },
  'a_appraisalClickOkrSchedule': {
    topicDesc: '系统首页-OKR进度概况',
    typeStatus:{
      '1': '管理端'
    },
    typeValue: {
      '1': '查看详情',
      '2': '查看高效员工',
      '3': '查看迟缓员工'
    }
  },
  'a_homeClickOkrSchedule': {
    topicDesc: '系统首页-OKR进度概况',
    typeStatus:{},
    typeValue: {
      '1': '点击高效员工总数',
      '2': '点击迟缓员工总数',
      '3': '点击员工头像'
    }
  },
  'a_appraisalClickOkrDepartmentSchedule': {
    topicDesc: '系统首页-各部门OKR进度概况',
    typeStatus:{
      '1': '管理端'
    },
    typeValue: {
      '1': '查看详情'
    }
  },
  'a_homeClickOkrDepartmentSchedule': {
    topicDesc: '系统首页-各部门OKR进度概况',
    typeStatus:{},
    typeValue: {
      '1': '查看进度详情'
    }
  },
  'a_statisticWorkbenchDetail': {
    topicDesc: '系统首页-智数看板',
    typeStatus:{},
    typeValue: {}
  },


  

  // 引导埋点
  'a_home_Guide': {
    topicDesc: "招聘-上线引导-视频弹框",
    typeStatus: {
      1: "2021-12-20新版本引导"
    },
    typeValue: {
      1: "跳过",
      2: "下一个",
      3: "上一个",
      4: "完成",
    }
  },
  // 低代码引导弹框埋点
  'a_home_new-function-guide': {
    topicDesc: "低代码-引导",
    typeStatus: {
      "1": "关闭",
      "2": "确定",
      "3": '查看',
      "4": '开启',
      "5": '关闭开启'
    },
    typeValue: {
    }
  }
}
